import { CRUD, DataType, VideoEditVideoSettingsScreen } from '@/interfaces'
import { RouteRecordRaw } from 'vue-router'

const myFeedRoutes: RouteRecordRaw[] = [
  {
    path: 'content-sources',
    name: 'imports',
    // component: () => import('@/views/content/MyImportsPage.vue'),
    meta: {
      title: 'imports',
      navbar: 'imports',
      insideLayout: true
    },
    props: true,
    children: [
      {
        path: 'edit/:id',
        name: 'cd-edit-stream',
        component: () => import('@/components/content/videos/my-imports/edit/MyImportsEditStream.vue'),
        props: true,
        meta: {
          title: 'stream',
          navbar: 'imports',
          hideProcessingPanel: true
        }
      }
    ]
  },
  {
    path: 'folders',
    name: 'folders',
    meta: {
      title: 'folders',
      navbar: 'videos'
    },
    props: true,
    children: [
      {
        path: 'view/:folderId',
        name: 'view-folder',
        component: () => import('@/views/myfeed/folder/FoldersPage.vue'),
        props: true,
        children: [
          {
            path: 'folder-video-edit/:id',
            name: 'folder-video-edit',
            component: () => import('@/components/content/videos/EditVideoSettings.vue'),
            props: true,
            meta: {
              title: 'folders',
              modal: true,
              hideRouter: true,
              hideProcessingPanel: true
            },
            children: [
              {
                path: 'closeunsaved',
                name: 'content-folder-edit-video-closeUnsaved',
                component: () => import('@/components/modals/custom-confirmation/CustomConfirmation.vue'),
                meta: {
                  title: 'folders'
                },
                props: { type: DataType.Video, action: CRUD.ConfirmClose }
              }
            ]
          },
          {
            path: 'createplaylist',
            name: 'folder-createplaylist',
            component: () => import('@/components/modals/createplaylist/CreatePlaylist.vue'),
            meta: {
              title: 'playlists',
              modal: true,
              hideProcessingPanel: true
            }
          }
        ],
        meta: {
          title: 'folders',
          fullscreen: true
        }
      },
      {
        path: 'edit/:id',
        name: 'edit-folder',
        component: () => import('@/components/content/videos/folders/edit/EditFolder.vue'),
        props: true,
        meta: {
          title: 'folders',
          modal: true,
          hideProcessingPanel: true
        },
        children: [
          {
            path: 'closeunsaved',
            name: 'edit-closeUnsavedFolder',
            component: () => import('@/components/modals/custom-confirmation/CustomConfirmation.vue'),
            meta: {
              title: 'folders'
            },
            props: { type: DataType.Folder, action: CRUD.ConfirmClose }
          }
        ]
      },
      {
        path: 'delete/:id',
        name: 'delete-folder',
        component: () => import('@/components/modals/custom-confirmation/CustomConfirmation.vue'),
        meta: {
          title: 'folders',
          modal: true
        },
        props: { type: DataType.Folder, action: CRUD.Delete }
      }
    ]
  },
  {
    path: 'drafts',
    name: 'video-drafts',
    meta: {
      title: 'drafts',
      navbar: 'videos'
    },
    component: { render: () => null }
  },
  {
    path: 'videos',
    name: 'videos',
    meta: {
      title: 'videos',
      navbar: 'videos'
    },
    children: [
      {
        path: 'edit/:id',
        name: 'video-edit',
        component: () => import('@/components/content/videos/EditVideoSettings.vue'),
        props: true,
        meta: {
          title: 'videos',
          navbar: 'videos',
          modal: true,
          hideProcessingPanel: true
        },
        beforeEnter: (to, from, next) => {
          if (!to.query.tab) {
            next({
              name: to.name,
              params: to.params,
              query: { ...to.query, tab: VideoEditVideoSettingsScreen.AddToPlaylist },
              replace: true
            })
          } else {
            next()
          }
        },
        children: [
          {
            path: 'closeunsaved',
            name: 'content-video-edit-closeUnsaved',
            component: () => import('@/components/modals/custom-confirmation/CustomConfirmation.vue'),
            meta: {
              title: 'videos'
            },
            props: { type: DataType.Video, action: CRUD.ConfirmClose }
          }
        ]
      },
      {
        path: 'createplaylist',
        name: 'videos-createplaylist',
        component: () => import('@/components/modals/createplaylist/CreatePlaylist.vue'),
        meta: {
          title: 'playlists',
          modal: true,
          hideProcessingPanel: true
        },
        children: [
          {
            path: 'closeunsaved',
            name: 'content-closeUnsavedPlaylist',
            component: () => import('@/components/modals/custom-confirmation/CustomConfirmation.vue'),
            meta: {
              title: 'videos'
            },
            props: { type: DataType.Playlist, action: CRUD.ConfirmClose }
          }
        ]
      },
      {
        path: 'details/:id',
        name: 'videos-details',
        component: () => import('@/components/content/library/details/VideoDetails.vue'),
        meta: {
          title: 'videos',
          modal: true
        },
        children: [
          {
            path: 'share',
            name: 'videos-video-details-share',
            component: () => import('@/components/content/library/VideoShare.vue'),
            meta: {
              title: 'urls'
            }
          }
        ]
      },
      {
        path: 'add',
        name: 'add-video',
        component: () => import('@/views/myfeed/my-videos/new-upload/NewUpload.vue'),
        meta: {
          title: 'addvideo',
          fullscreen: true,
          hideProcessingPanel: true
        },
        props: true,
        children: [
          {
            path: 'closeunsaved',
            name: 'add-close-unsaved-video',
            component: () => import('@/components/modals/custom-confirmation/CustomConfirmation.vue'),
            meta: {
              title: 'playlists'
            },
            props: { type: DataType.Video, action: CRUD.CloseCreate }
          }
        ]
      },
      {
        path: 'addstream',
        name: 'add-stream',
        component: () => import('@/components/content/videos/my-videos/add-stream/AddStream.vue'),
        meta: {
          title: 'addstream',
          navbar: 'imports',
          fullscreen: true,
          hideProcessingPanel: true
        },
        props: true
      },
      {
        path: 'delete/:id',
        name: 'delete-video',
        component: () => import('@/components/modals/custom-confirmation/CustomConfirmation.vue'),
        meta: {
          title: 'videos',
          modal: true
        },
        props: { type: DataType.Video, action: CRUD.Delete }
      }
    ]
  },
  {
    path: 'channel',
    name: 'channel',
    component: () => import('@/components/content/videos/my-channel/PreviewChannel.vue'),
    meta: {
      title: 'channel',
      navbar: 'channel',
      insideLayout: true
    },
    props: true,
    children: [
      {
        path: 'edit',
        name: 'edit-channel',
        component: () => import('@/components/content/videos/my-channel/edit/EditChannel.vue'),
        meta: {
          title: 'channel',
          navbar: 'channel',
          modal: true,
          hideProcessingPanel: true
        },
        props: true
      }
    ]
  }
]

export default myFeedRoutes
